module.exports = __webpack_public_path__ + "img/index-slider-4.27bd9290.svg";